<map name="popup">
    <img src="assets/images/popup/popup_ase_VUF_500x300.jpg" alt="Verificación Unica Fiscal" usemap="#popup" (load)="imageResized();">
    <!-- boton Confirmar -->
    <area fxHide.xs fxShow.gt-md style="cursor: pointer;" shape="rect" coords="350, 235, 462, 265" (click)="goForm()">
    <!-- x -->
    <area fxHide.xs fxShow.gt-md style="cursor: pointer;" shape="rect" coords="458, 0, 500, 41" (click)="closeDialog()"> 
   
</map>

